import SpainContractType from 'modules/contracts/store/models/SpainContractType'

import { PayrollLegalEntityResource } from '../payrollLegalEntityResource'

export interface IContractType {
  id: number
  legal_entity_id: number
  name: string
  default: boolean
  archived: boolean
}

class ContractTypes extends PayrollLegalEntityResource<SpainContractType> {
  get cacheKey(): string {
    return 'spainContractTypes'
  }

  model() {
    return SpainContractType
  }
}

export { ContractTypes }
